import { datadogRum } from '@datadog/browser-rum'

// Logger's Datadog transports only forward errors, so non-error telemetry goes straight to RUM.
export const addRumAction = (name, context) => {
  datadogRum.addAction(name, context)
}
